export const photos = [
  {
    id: 1,
    title: "Spring Collection",
    imageUrl: "/images/photo1.jpg",
    imageDate: "2024-03-15",
    vendors: ["Little Fashion Co.", "Spring Kids"],
    description: "Elegant spring fashion shoot featuring our latest collection of children's clothing. Natural lighting and outdoor setting create a fresh, vibrant look perfect for the season.",
    category: "fashion"
  },
  {
    id: 2,
    title: "Summer Vibes",
    imageUrl: "/images/photo2.jpg",
    imageDate: "2024-06-20",
    vendors: ["Summer Style", "Beach Kids"],
    description: "Bright and cheerful summer collection showcasing comfortable, stylish clothing perfect for warm weather adventures.",
    category: "fashion"
  },
  {
    id: 3,
    title: "Autumn Elegance",
    imageUrl: "/images/photo3.jpg",
    imageDate: "2024-09-10",
    vendors: ["Fall Fashion", "Cozy Kids"],
    description: "Warm autumn tones and cozy textures highlight this seasonal collection designed for comfort and style during cooler months.",
    category: "fashion"
  },
  {
    id: 4,
    title: "Winter Wonderland",
    imageUrl: "/images/photo4.jpg",
    imageDate: "2024-12-05",
    vendors: ["Winter Wear", "Snow Kids"],
    description: "Magical winter collection featuring warm, stylish clothing perfect for holiday photos and cold weather activities.",
    category: "fashion"
  },
  {
    id: 5,
    title: "Casual Comfort",
    imageUrl: "/images/photo5.jpg",
    imageDate: "2024-04-12",
    vendors: ["Comfort Kids", "Everyday Style"],
    description: "Everyday comfort meets style in this casual collection designed for active children who love to play and explore.",
    category: "casual"
  },
  {
    id: 6,
    title: "Party Perfect",
    imageUrl: "/images/photo6.jpg",
    imageDate: "2024-05-18",
    vendors: ["Party Wear", "Special Occasions"],
    description: "Special occasion clothing that makes every celebration memorable with elegant designs and premium fabrics.",
    category: "formal"
  },
  {
    id: 7,
    title: "Outdoor Adventure",
    imageUrl: "/images/photo7.jpg",
    imageDate: "2024-07-22",
    vendors: ["Adventure Kids", "Outdoor Gear"],
    description: "Durable and stylish clothing designed for outdoor adventures, featuring breathable fabrics and practical designs.",
    category: "outdoor"
  },
  {
    id: 8,
    title: "School Days",
    imageUrl: "/images/photo8.jpg",
    imageDate: "2024-08-30",
    vendors: ["School Style", "Academic Wear"],
    description: "Back-to-school collection combining comfort and style for the academic year ahead.",
    category: "school"
  }
];

export const categories = [
  { id: "all", name: "All Photos" },
  { id: "fashion", name: "Fashion" },
  { id: "casual", name: "Casual" },
  { id: "formal", name: "Formal" },
  { id: "outdoor", name: "Outdoor" },
  { id: "school", name: "School" }
];
